import React from 'react';
import ClipboardJS from 'clipboard';

const ShareLink = function ShareLink(props) {
  new ClipboardJS('.btn');
  const urlHost = window.location.host;
  const path = props.path;
  const shareLink = `${urlHost}${path}`;

  return (
    <div className="w-full">
      <div className="flex copy-link">
        <button
          className={`ui btn button copy-button max-w-fit ${props.button_class}`}
          data-clipboard-target="#shareLink"
        >
          Copy
        </button>
        <input
          id="shareLink"
          placeholder="Link to Copy"
          value={shareLink}
          readOnly
          className="pl-2 share-link-input w-full"
        />
      </div>
    </div>
  );
};

export default ShareLink;
